import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useLanguageStore } from "@/providers/useLanguageStore";
interface OnDemandItemProps {
  course: {
    _id: string;
    name: string;
    description: string;
    coverThumbnail: string;
    coursePrice: number;
    published: boolean;
    ranking?: number;
    monetization?: {
      discount: number;
      finalPrice: number;
      price: number;
    };
  };
}
const OnDemandItem: React.FC<OnDemandItemProps> = ({ course }) => {
  const { coursePrice, monetization } = course;
  const { discount = 0, finalPrice = 0, price = 0 } = monetization || {};
  const { translations } = useLanguageStore();
  return (
    <div className="relative border shadow-md p-6 w-full sm:w-[80%] md:w-[45%] lg:w-[35%] xl:w-[30%] flex flex-col justify-between h-100">
      <Image
        width={400}
        height={400}
        src={course.coverThumbnail}
        alt={course.name}
        unoptimized
        className="object-cover w-full h-48 mb-4"
      />
      <div className="flex flex-col flex-grow">
        <Link
          href={`https://universe.rollingcodeschool.com/explore/course/${course._id}`}
          target="_blank"
          passHref
        >
          <h3 className="mb-1 overflow-hidden text-xl font-bold text-red-600 overflow-ellipsis line-clamp-2">
            {course.name}
          </h3>
        </Link>
        <p className="mb-4 text-sm italic text-gray-600">by RollingCode</p>
        {course.ranking && (
          <p className="mb-2 text-sm text-yellow-500">
            Ranking:
            {Array.from({ length: course.ranking }, (_, index) => (
              <span key={index}>⭐</span>
            ))}
          </p>
        )}
        <p className="mb-1 overflow-hidden text-sm text-gray-700 overflow-ellipsis line-clamp-5">
          {course.description || "Sin descripción disponible"}
        </p>
        <div className="mt-auto">
          {coursePrice === 0 ? (
            <p className="text-2xl font-semibold text-red-600">
              {translations.free || "¡Gratis!"}
            </p>
          ) : discount > 0 ? (
            <div className="flex items-center gap-2">
              <p className="text-sm text-gray-500 line-through">${price}</p>
              <p className="text-xl font-semibold text-red-600">
                ${finalPrice}
              </p>
              <p className="px-2 py-1 text-sm text-green-700 bg-green-100">
                {discount}% OFF
              </p>
            </div>
          ) : (
            <p className="text-xl font-semibold text-red-600">${price}</p>
          )}
        </div>
        <Link
          href={`https://universe.rollingcodeschool.com/explore/course/${course._id}`}
          target="_blank"
          passHref
        >
          <button className="w-full py-2 mt-3 font-bold text-white bg-red-600 hover:bg-red-700">
            {translations.chooseCareerSignUp || "INSCRIBIRME AHORA"}
          </button>
        </Link>
      </div>
    </div>
  );
};
export default OnDemandItem;
